import type { PaymentMethod } from '@/services/platformApi';

/** Stripe charge / charge-and-save endpoints require a Stripe pm_* id, not the platform UUID. */
export function resolveStripePaymentMethodId(method: PaymentMethod): string {
  const fromDetails = method.details?.paymentMethodId;
  if (typeof fromDetails === 'string' && fromDetails.startsWith('pm_')) {
    return fromDetails;
  }
  if (typeof method.id === 'string' && method.id.startsWith('pm_')) {
    return method.id;
  }
  throw new Error('Could not resolve Stripe payment method ID. Please try entering your card again.');
}
